let swiperRegistered = false;

/**
 * Registra os custom elements do Swiper sob demanda (Lever 1).
 *
 * Antes, `registerSwiperElements()` rodava no main.ts para 100% das visitas,
 * pondo ~370KB de Swiper no vendor eager e executando os define() no boot —
 * mas só as telas com carrossel de destaques (header) usam
 * <swiper-container>. Aqui o bundle é import()-ado só quando essas telas de
 * fato têm imagens de destaque. Custom elements fazem upgrade retroativo, então
 * registrar depois de o <swiper-container> já estar no DOM funciona.
 */
export async function ensureSwiperRegistered(): Promise<void> {
	if (swiperRegistered) return;
	swiperRegistered = true;
	const { register } = await import('swiper/element/bundle');
	register();
}
